// src/api/watchListing.js
import { baseApi } from "./apiConfig";

export const getWatchListing = async (propertyId = 0) => {
  try {
    const timestamp = new Date().getTime();
    const response = await baseApi.get(
      `/portal/watchListing/${propertyId}?_=${timestamp}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching watch listing:", error);
    throw error;
  }
};

export const subscribeUser = (email) => {
  const formData = new FormData();
  formData.append("emailId", email);
  return baseApi
    .post("portal/lean-regn/subscribeUser", formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        return response.data;
      }
      return null;
    });
};

export const deleteFavorite = async (propertyId) => {
  try {
    const payload = { propertyId: propertyId };
    const response = await baseApi.post("portal/deleteWatch", payload);
    return response.data;
  } catch (error) {
    console.error("Error deleting favorite:", error);
    throw error;
  }
};
// Add this function to your favorites.js file

export const getUserSavedProperties = async (emailId, pageNumber, pageSize) => {
  try {
    const payload = {
      emailId: emailId,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    const response = await baseApi.post(
      "/portal/drawer/getUserSavedProperties",
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching saved properties:", error);
    throw error;
  }
};
